// extracted by mini-css-extract-plugin
module.exports = {"day":"day-28cYy","dayOfWeekName":"dayOfWeekName-38YAc","week":"week-nv4Pu"};